(function () {
    'use strict';
    var controllerId = 'schedaCompetenzeConoscenzeEdit';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'common', 'schedaCompetenzeConoscenze', schedaCompetenzeConoscenzeEditFn]);

    function schedaCompetenzeConoscenzeEditFn($scope, $uibModalInstance, datacontext, common, schedaCompetenzeConoscenze) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.schedaCompetenzeConoscenze = schedaCompetenzeConoscenze;
        $scope.Titolo = 'Modifica Scheda Competenze - Conoscenze';

        //console.info("schedaCompetenzeAbilita", schedaCompetenzeAbilita);
        $scope.orightml = schedaCompetenzeConoscenze.Conoscenze;
        $scope.htmlcontent = $scope.orightml;
        $scope.disabled = false;

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = {};
                $scope.schedaCompetenzeConoscenze.Conoscenze = $scope.htmlcontent;
                $uibModalInstance.close($scope.schedaCompetenzeConoscenze);
                

                //editItem($scope.schedaCompetenzeAbilita).then(function (result) {
                //    console.info("result",result);
                //        if (result.Id && result.Id > 0)
                //            $uibModalInstance.close(result);
                //    });
                
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

      

       
    }
    
})();